const Subcription = () => {
  return <h1 className="text-lg font-bold text-gray-600 mb-1">Subcription</h1>;
};

export default Subcription;
